import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'
import { app } from 'router/routes'
import { AbilityContext } from 'components/Permissions/Can'
import { Chip } from 'components/Form'
import { DashboardContext } from '../DashboardContext'
import StatCard from './StatCard'
import { closedBg, closedText } from './Style'

// קוביית "התקדמות בביצוע המבדקים בסמסטר זה"
const SemesterProgressCard = () => {
    const navigate = useNavigate()
    const ability = useContext(AbilityContext)
    const { dashboardData } = useContext(DashboardContext)

    const {
        total_batteries = 0,
        completed_batteries = 0,
        partial_batteries = 0,
        not_started_batteries = 0,
        done_assessments = 0,
        remaining_assessments = 0,
        due_date
    } = dashboardData.battery_progress || {}

    const percent = total_batteries ? (completed_batteries / total_batteries) * 100 : 0

    return (
        <StatCard
            className='progress-card'
            title={"התקדמות בביצוע המבדקים בסמסטר זה"}
            headSide={due_date &&
                <Chip round color={closedText} bg={closedBg}>{`מועד אחרון: ${dayjs(due_date).format('DD.MM.YY')}`}</Chip>}
        >
            <div className='progress-section'>
                <div className='progress-main'>
                    <span className='top-card-value'>{completed_batteries}</span>
                    <span>
                        <span className='progress-of'>{`מתוך ${total_batteries} סוללות בוצעו `}</span>
                        <span className='muted-small'>{`(${done_assessments} מבדקים)`}</span>
                    </span>
                </div>
                <div className='progress-track'>
                    <div className='progress-fill' style={{ width: `${percent}%` }} />
                </div>
            </div>

            <div className='progress-bottom'>
                <div className='progress-remaining'>
                    <span className='muted-small'>{`${partial_batteries} סוללות בוצעו בחלקן`}</span>
                    <span>
                        <span className='remaining-main'>{`${not_started_batteries} סוללות נותרו לביצוע`}</span>
                        <span className='muted-small'>{` (${remaining_assessments} מבדקים)`}</span>
                    </span>
                </div>
                {ability.can("read", "perform-assessments") &&
                    <button className='pill-btn inline' onClick={() => navigate(app.performAssessments)}>
                        {"לביצוע המבדקים"}
                        <i className="fa-regular fa-arrow-left-long" />
                    </button>}
            </div>
        </StatCard>
    )
}

export default SemesterProgressCard
